import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Grid, Typography } from "@mui/material"
import { TabsSeeker } from "@ui-seeker/core"
import { formatDate } from "@ui-seeker/utils"

import { ImageSkuBlock, LabelCountry, SkuLinkLabel, HierarchicalTextBlock } from "@components"
import { AdminNewListedDetailsDrawerContentTabDescription, AdminNewListedDetailsDrawerContentTabFeatures, AdminNewListedDetailsDrawerContentTabInternalInfo } from "./Tabs"
import { ActualListBlock } from "../@components"
import { adminNewListedDetails } from "../@signals"


export default function AdminNewListedDetailsDrawerContent() {
	const displayInfoID = useSignal(0)

	const {
		brandRaw, country, retailer, date, thumbnail, productName, ean, productURL, actualPrice, listPrice,
		currency, category, ...extraData
	} = adminNewListedDetails.value

	return <Grid container spacing={2}>
		<Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
			<Typography variant="h5">{brandRaw}</Typography>
			<LabelCountry country={country} label={retailer} />
			<Typography>{formatDate(date, { isString: true })}</Typography>
		</Grid>

		<Grid item xs={12}>
			<ImageSkuBlock
				hideName
				imageURL={thumbnail}
				name={productName}
				height={300}
				isClickable={false}
			/>
		</Grid>

		<Grid item xs={12}>
			<SkuLinkLabel url={productURL} skuName={productName} ellipsis={false} variant="h5" />
			<HierarchicalTextBlock title="EAN: " titleValue={ean || '--'} />
			<HierarchicalTextBlock title="Category: " titleValue={category || '--'} />
		</Grid>
		<Grid item xs={12}>
			<ActualListBlock actualPrice={actualPrice} listPrice={listPrice} currency={currency} variant="subtitle1" />
		</Grid>

		<Grid item xs={12}>
			<TabsSeeker
				showTabID={displayInfoID.value}
				onChange={(_, newValue) => displayInfoID.value = newValue}
				tabs={[
					{ label: 'Features', value: 0 },
					{ label: 'Description', value: 1 },
					{ label: 'Internal Info', value: 2 },
				]}
			/>
		</Grid>

		<Grid item xs={12}>
			{ displayInfoID.value === 0 && <AdminNewListedDetailsDrawerContentTabFeatures {...extraData} currency={currency} /> }
			{ displayInfoID.value === 1 && <AdminNewListedDetailsDrawerContentTabDescription {...extraData} /> }
			{ displayInfoID.value === 2 && <AdminNewListedDetailsDrawerContentTabInternalInfo {...extraData} /> }
		</Grid>
	</Grid>
}